/* unplugin-vue-components disabled */import script from "./Navber.vue?vue&type=script&setup=true&lang=js"
export * from "./Navber.vue?vue&type=script&setup=true&lang=js"

import "./Navber.vue?vue&type=style&index=0&id=40fd547c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40fd547c"]])

export default __exports__